import common from '../common'

export default {
    list(params) {
      return common.get('/rocheManage/sys/notice/list',params);
    },
  
    add(params) {
      return common.post('/rocheManage/sys/notice/add',params);
    },
  
    edit(params) {
      return common.put('/rocheManage/sys/notice/edit',params);
    },
  
    delete(params) {
      return common.delete('/rocheManage/sys/notice/delete',params);
    },
  
    deleteBatch(params) {
      return common.delete('/rocheManage/sys/notice/deleteBatch',params);
    },

    getNoticeHomeList() {
      return common.get('/rocheManage/sys/notice/home/list');
    },

    exportXls(params) {
      return common.get('/rocheManage/sys/notice/exportXls', params, {responseType: 'blob'});
    },
}


// WEBPACK FOOTER //
// ./src/api/sysmanagement/systemnotice.js